import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { trigger, transition, style, animate } from "@angular/animations";
import BackgroundScroll from "../utils/background-scroll.util";

export interface MxLeftPopupOption {
	closeFromOutside?: boolean;
	hideCloseButton?: boolean;
	callBackAfterClose?: any;
	styleClass?: string;
}

const slideLeftAnimation = [
	trigger("slideDownToggle", [
		transition(":enter", [
			style({ transform: "translateX(-100%)" }),
			animate("300ms ease-in", style({ transform: "translateX(0%)" })),
		]),
		transition(":leave", [
			animate("300ms ease-in", style({ transform: "translateX(-100%)" })),
		]),
	]),
];
@Component({
	selector: "meu-pop-up-left",
	templateUrl: "./pop-up-left.component.html",
	styleUrls: ["./pop-up-left.component.scss"],
	animations: [slideLeftAnimation],
})
export class PopUpLeftComponent implements OnInit {
	@Input() isOpen = false;
	defaultOption: MxLeftPopupOption = {
		closeFromOutside: true,
		hideCloseButton: false,
		callBackAfterClose: null,
	};
	@Input("options") option;
	bgScrollDisable: BackgroundScroll = new BackgroundScroll();

	@Output() changed_task_id = new EventEmitter(); // use for task-detail component
	constructor() {}

	ngOnInit() {
		this.setDefaultValue();
		if (this.isOpen) {
			this.bgScrollDisable.disable(true);
		}
	}

	setDefaultValue() {
		if (this.option) {
			const inputOption = this.option;
			this.option = {
				...this.defaultOption,
				...inputOption,
			};
		} else {
			this.option = this.defaultOption;
		}
	}

	open() {
		this.isOpen = true;
		this.bgScrollDisable.disable(true);
	}

	close() {
		this.isOpen = false;
		if (this.option.callBackAfterClose != null) {
			this.option.callBackAfterClose();
		}
		this.bgScrollDisable.disable(false);
		this.changed_task_id.emit(true);
	}

	closeFromOutside() {
		if (this.option.closeFromOutside) {
			this.close();
		}
	}

	ngOnDestroy(): void {
		this.bgScrollDisable.disable(false);
	}
}
